import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
import '@tokens/typography.stylex';
import { typography } from '@tokens/typography.stylex';
import '@tokens/spacing.stylex';
import { spacing } from '@tokens/spacing.stylex';
import '@tokens/radius.stylex';
import { radius } from '@tokens/radius.stylex';
import '@tokens/motion.stylex';
import { motion } from '@tokens/motion.stylex';
import '@tokens/shadows.stylex';
import { shadows } from '@tokens/shadows.stylex';

// Ported 1:1 from the prototype `.topbar` + `.crumb` + `.icon-btn`.
const spin = "x1wc8ddo-B";
export const styles = {
  bar: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "x1bof9c1",
    kZKoxP: "xdd8jsf",
    kmuXW: "x2lah0s",
    kg3NbH: "xytz8ft",
    kt9PQ7: "xso031l",
    kfdmCh: "x1q0q8m5",
    kL6WhQ: "xra1o3",
    kWkggS: "x10izuvt",
    k6WDB: "x1dmgsgi",
    kVAEAm: "x7wzq59",
    k87sOh: "x13vifvy",
    kY2c9j: "x68pp3s",
    $$css: true
  },
  searchTrigger: {
    kI3sdo: "x1a2a7pz xx4dj4q",
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "x1fwedmp",
    k7Eaqz: "xeuugli",
    kZKoxP: "x90ne7k",
    kzqmXN: "x1m258z3 x1w3t4m0 x1o2krsx",
    kg3NbH: "xy65nll x8btr5i",
    kjj79g: "x1nhvcw1 x1l8dr4e",
    kaIpWk: "xxltkoq",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x1xo1f5v",
    kWkggS: "x16vpd03",
    kMwMTN: "xdxw5r1",
    kMv6JI: "xdv2sak",
    kGuDYH: "x2pyw9z",
    kkrTdU: "x1ypdohk",
    kmkexE: "x1k3q35m",
    kaVNsj: "x17y7a7r",
    kDPRdz: "x1tqbdv0",
    $$css: true
  },
  searchActionsGroup: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "x1bof9c1",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  searchTriggerText: {
    kUk6DE: "x98rzlu",
    k7Eaqz: "xeuugli",
    k9WMMc: "xdpxx8g",
    kVQacm: "xb3r6kr",
    kg5iWk: "xlyipyv",
    khDVqt: "xuxw1ft",
    k1xSpc: "x1lliihq x1g9v1si",
    $$css: true
  },
  searchKbd: {
    kMv6JI: "x1gs96k",
    kGuDYH: "x34ze3o",
    kMwMTN: "xdxw5r1",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x1xo1f5v",
    kaIpWk: "x1d0dq8e",
    kmVPX3: "xeb2tmb",
    kmuXW: "x2lah0s",
    k1xSpc: "x1rg5ohu x1g9v1si",
    $$css: true
  },
  crumb: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "xr8clws",
    kGuDYH: "x2pyw9z",
    kMwMTN: "xdxw5r1",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  hideCompact: {
    k1xSpc: "x78zum5 x1a1oztq",
    $$css: true
  },
  showCompact: {
    k1xSpc: "x1s85apg x3992on",
    $$css: true
  },
  crumbCompact: {
    k1xSpc: "x78zum5 xjwlzi0",
    $$css: true
  },
  menuSectionLabel: {
    kGuDYH: "x34ze3o",
    kb6lSQ: "xbxvrrg",
    kP9fke: "xtvhhri",
    kMwMTN: "xdxw5r1",
    k63SB2: "xomqrzn",
    kmVPX3: "x1hlgpag",
    $$css: true
  },
  menuSlot: {
    kmVPX3: "xttybi9",
    $$css: true
  },
  crumbSep: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kMwMTN: "xdxw5r1",
    kmuXW: "x2lah0s",
    $$css: true
  },
  crumbStrong: {
    kMwMTN: "x1oezkus",
    k63SB2: "xomqrzn",
    kVQacm: "xb3r6kr",
    kg5iWk: "xlyipyv",
    khDVqt: "xuxw1ft",
    $$css: true
  },
  collapseBtn: {
    kI3sdo: "x1a2a7pz xx4dj4q",
    k1xSpc: "x3nfvp2",
    kGNEyG: "x6s0dn4",
    kjj79g: "xl56j7k",
    kzqmXN: "x1td3qas",
    kZKoxP: "x10w6t97",
    kmuXW: "x2lah0s",
    kaIpWk: "xxltkoq",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x1xo1f5v",
    kWkggS: "x16vpd03",
    kMwMTN: "xdxw5r1",
    kkrTdU: "x1ypdohk",
    kmkexE: "xqjhk8t",
    kGzVvX: "x5lqt2c",
    kDPRdz: "x1tqbdv0",
    $$css: true
  },
  spacer: {
    kUk6DE: "x98rzlu",
    $$css: true
  },
  iconBtn: {
    kI3sdo: "x1a2a7pz xq8uqhm",
    kInvED: "x2ssjo2",
    kVAEAm: "x1n2onr6",
    kzqmXN: "x14qfxbe",
    kZKoxP: "xc9qbxq",
    k1xSpc: "xrvj5dj",
    kgQiWS: "x1ku5rj1",
    kjj79g: "xl56j7k",
    kGNEyG: "x6s0dn4",
    kaIpWk: "xxltkoq",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x9r1u3d",
    kWkggS: "xjbqb8w",
    kMwMTN: "xdxw5r1",
    kkrTdU: "x1ypdohk",
    kmkexE: "x1k3q35m",
    kGzVvX: "x5lqt2c",
    kDPRdz: "x1tqbdv0",
    $$css: true
  },
  iconBtnSpinning: {
    kMwMTN: "x1459q0w",
    kfzvcC: "x47corl",
    kKVMdj: "x1aerksh",
    k44tkh: "xegkacw",
    kyAemX: "x1esw782",
    ko0y90: "xa4qsjk",
    $$css: true
  },
  langCode: {
    kGuDYH: "x34ze3o",
    k63SB2: "x1xlr1w8",
    kb6lSQ: "x1dgsrnt",
    $$css: true
  },
  menuWrap: {
    kVAEAm: "x1n2onr6",
    $$css: true
  },
  langBtn: {
    kzqmXN: "x14atkfc",
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "xr8clws",
    kg3NbH: "x1g3f1de",
    $$css: true
  },
  chev: {
    kmuXW: "x2lah0s",
    kmkexE: "x1ojvxoa",
    $$css: true
  },
  chevOpen: {
    k3aq6I: "x19jd1h0",
    $$css: true
  },
  menu: {
    kVAEAm: "x10l6tqk xegw5ml",
    k87sOh: "xwwefxd x150vwk6",
    kCIrl2: "x3m8u43 x77kb69",
    kY2c9j: "xf5e64p",
    k7Eaqz: "xfb3i0g",
    ks0D6T: "xvv7f4i",
    kskxy: "x7ab17h x18opn6o",
    kORKVm: "xryxfnj x37gjbb",
    kmVPX3: "xrqf348",
    kWkggS: "x13uruat",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "xaj8nyx",
    kaIpWk: "xxltkoq",
    kGVxlE: "xkqgayn",
    $$css: true
  },
  menuWide: {
    k7Eaqz: "xcqhk00",
    $$css: true
  },
  menuHeader: {
    kmVPX3: "x1160tuk",
    kt9PQ7: "xso031l",
    kfdmCh: "x1q0q8m5",
    kL6WhQ: "xra1o3",
    k1K539: "x1vvky8i",
    $$css: true
  },
  menuUserName: {
    kGuDYH: "x2pyw9z",
    k63SB2: "xomqrzn",
    kMwMTN: "x1oezkus",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  menuUserRole: {
    kGuDYH: "x34ze3o",
    kMwMTN: "xdxw5r1",
    keoZOQ: "xr9ek0c",
    $$css: true
  },
  menuItem: {
    kI3sdo: "x1a2a7pz xq8uqhm",
    kInvED: "x2ssjo2",
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "x1mnnc3i",
    kzqmXN: "xh8yej3",
    kmVPX3: "x1160tuk",
    kaIpWk: "x1d0dq8e",
    kWkggS: "xjbqb8w",
    kkrTdU: "x1ypdohk",
    kMv6JI: "xdv2sak",
    kGuDYH: "x2pyw9z",
    k63SB2: "xssbmp7",
    kMwMTN: "xdxw5r1",
    k9WMMc: "xdpxx8g",
    kybGjl: "x1hl2dhg",
    kmkexE: "x1k3q35m",
    kGzVvX: "x5lqt2c",
    kDPRdz: "x1tqbdv0",
    $$css: true
  },
  menuItemOn: {
    kMwMTN: "x1oezkus",
    $$css: true
  },
  menuSection: {
    kmVPX3: "xv5wz92",
    kGuDYH: "x1sfnd48",
    k63SB2: "xomqrzn",
    kb6lSQ: "x1dgsrnt",
    kP9fke: "xtvhhri",
    kMwMTN: "xdxw5r1",
    $$css: true
  },
  menuDivider: {
    kqGvvJ: "xy5juzm",
    kEafiO: "x178xt8z",
    kPef9Z: "x13fuv20",
    kLZC3w: "x1p7xzfl",
    $$css: true
  },
  accountRow: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "x195vfkc",
    $$css: true
  },
  accountPick: {
    kUk6DE: "x98rzlu",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  accountLines: {
    k1xSpc: "x78zum5",
    kGNEyG: "x1pha0wt",
    kOIVth: "x1fwedmp",
    kUk6DE: "x98rzlu",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  accountName: {
    kGuDYH: "x2pyw9z",
    k63SB2: "xssbmp7",
    kVQacm: "xb3r6kr",
    kg5iWk: "xlyipyv",
    khDVqt: "xuxw1ft",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  accountRole: {
    kmuXW: "x2lah0s",
    kGuDYH: "x34ze3o",
    kMwMTN: "xdxw5r1",
    $$css: true
  },
  accountAvatar: {
    k1xSpc: "xrvj5dj",
    kgQiWS: "x1ku5rj1",
    kmuXW: "x2lah0s",
    kzqmXN: "x17z2i9w",
    kZKoxP: "x17rw0jw",
    kaIpWk: "xoy5co8",
    kWkggS: "xvys5x3",
    kGuDYH: "x1sfnd48",
    k63SB2: "xomqrzn",
    kMwMTN: "x1oezkus",
    $$css: true
  },
  accountSignOut: {
    kI3sdo: "x1a2a7pz xq8uqhm",
    kInvED: "x2ssjo2",
    k1xSpc: "xrvj5dj",
    kgQiWS: "x1ku5rj1",
    kmuXW: "x2lah0s",
    kzqmXN: "xgd8bvy",
    kZKoxP: "x1fgtraw",
    kmVPX3: "x1717udv",
    kaIpWk: "x1d0dq8e",
    kWkggS: "xjbqb8w",
    kkrTdU: "x1ypdohk",
    kMwMTN: "xdxw5r1",
    kmkexE: "x1k3q35m",
    kGzVvX: "x5lqt2c",
    kDPRdz: "x1tqbdv0",
    $$css: true
  },
  menuItemLabel: {
    kUk6DE: "x98rzlu",
    $$css: true
  },
  menuCheck: {
    kMwMTN: "x1459q0w",
    $$css: true
  },
  avatarBtn: {
    kzqmXN: "x14atkfc",
    kg3NbH: "xfn1xvj",
    $$css: true
  },
  avatar: {
    kzqmXN: "xgd8bvy",
    kZKoxP: "x1fgtraw",
    kaIpWk: "xoy5co8",
    k1xSpc: "xrvj5dj",
    kgQiWS: "x1ku5rj1",
    kGuDYH: "x34ze3o",
    k63SB2: "xomqrzn",
    kMwMTN: "x1m3rtoy",
    kKwaWg: "x1w4ef1l",
    $$css: true
  }
};